export default "__VITE_ASSET__DzxX33XM__"